import * as React from 'react'
import styled from 'styled-components'

import { InfoErrorBox } from '~/components'
import { StandaloneLayout } from '~/layouts'
import { CenterContainer } from '~/layouts/standalone/elements'
import Anchor from '~/truck/anchor'
import Button from '~/truck/button'
import { images, riqraInfo } from '~/utils/constants'

const StyledContainer = styled(CenterContainer)`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.spacing.cozy * 6}px;
  min-height: calc(100vh - ${props => props.theme.spacing.cozy * 6}px);
`

const StyledButton = styled(Button)`
  text-decoration: auto;
  width: fit-content;
`

const ServerErrorScreen = () => {
  return (
    <StandaloneLayout>
      <StyledContainer>
        <InfoErrorBox
          imageSrc={images.ERROR_VENDOR_NOT_AVAILABLE}
          imageAlt="Vendor not available"
          title="Tienda no disponible"
          description={
            <>
              Lo sentimos, no hemos encontrado la tienda que buscabas. Si eres un visitante de esta tienda intenta más
              tarde, si eres el dueño <Anchor href={riqraInfo.helpCenter}>contacta a soporte.</Anchor>
            </>
          }
          action={
            <StyledButton
              color="secondary"
              forwardedAs="a"
              href="https://riqra.com/?utm_source=tiendas&utm_medium=error&utm_campaign=error_tiendas"
            >
              Crea tu tienda en riqra.com
            </StyledButton>
          }
        />
      </StyledContainer>
    </StandaloneLayout>
  )
}

export default ServerErrorScreen
